import { useCallback, useContext } from 'react';
import { generatePath, useHistory, useLocation } from 'react-router-dom';
import { BoxesTableContext } from '../contexts';
import { BoxTransfersRequestType } from '@modules/box-transfers';

export const useBoxesActionBar = () => {
  const { selection, selectAll, fetch, state, reset, resetSelection } = useContext(BoxesTableContext);

  const location = useLocation();
  const history = useHistory();

  const create = useCallback(() => {
    history.push('/@next/boxes/create', { background: location });
  }, [history, location]);

  const openBoxHistory = useCallback(
    (branchId) => {
      history.push(generatePath('/@next/box-transfers/:id/:type', { id: branchId, type: BoxTransfersRequestType.BRANCH }));
    },
    [history],
  );

  return { selection, state, resetSelection, create, selectAll, reset, fetch, openBoxHistory };
};
